<template>
     <div>
      <agile-table
      :data-type="'projectsInvoice'"
      :table-meta="tableMeta"
      :data="projects"
      :filter-meta="filterMeta"
      :column-meta="columnMeta"
      :show-context-menu=true
      @fieldAction="fieldAction"
      @tableAction="tableAction"
      @rowAction="rowAction" />
      <slideout-panel />
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import NewButton from '@/components/actions/CreateNewButton'
import ProjectModal from '@/components/modals/ProjectModal'
import AgileTable from '@/components/table/AgileTable'
import InvoicePreviewModal from '@/components/modals/InvoicePreviewModal'

export default {
  components: {
    NewButton,
    ProjectModal,
    AgileTable
  },
  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY,

      tableMeta: {
        heading: 'Fakturera',
        headingIcon: 'fa-file-invoice-dollar',
        displayPagination: true
        /*
        actions: [{
          label: 'Arkiv',
          action: 'goToArchive',
          iconClass: 'fal fa-archive'
        }]
        */
      },

      filterMeta:
      [
        {
          fieldId: 'projectCode',
          type: 'string',
          label: 'Projektnummer'
        },
        {
          fieldId: 'projectOwnerUserInitials',
          type: 'string',
          label: 'Ansvarig'
        },
        {
          fieldId: 'projectReviewerUserInitials',
          type: 'string',
          label: 'Granskare'
        },
        {
          fieldId: 'active',
          type: 'bool',
          label: 'Aktiva'
        }
      ],
      /*
      actionMeta: {
        type: 'buttons',
        items: [{
          label: 'Granska',
          action: 'reviewInvoice',
          iconClass: 'fal fa-search'
        }]
      },
      */
      columnMeta:
      {
        hasActions: true,
        items:
        [
          {
            fieldId: 'projectCode',
            label: 'Projektnummer'
          },
          {
            fieldId: 'block',
            label: 'Objekt'
          },
          {
            fieldId: 'customerName',
            label: 'Kund'
          },
          {
            fieldId: 'mainContactFullName',
            label: 'Beställare'
          },
          {
            fieldId: 'objectAddressFormatted',
            label: 'Adress'
          },
          /*
          {
            fieldId: 'numberOfTags',
            label: 'Taggar',
            actionType: 'fieldAction',
            action: 'displayTags',
            iconClass: 'fal fa-tag'
          },
          */
          {
            fieldId: 'planned',
            label: 'Planerade'
          },
          {
            fieldId: 'registered',
            label: 'Registrerade'
          },
          {
            fieldId: 'invoiced',
            label: 'Fakturerade'
          },
          {
            fieldId: 'budget',
            label: 'Budget',
            dataType: 'currency'
          }
          /*
          {
            fieldId: 'amountInvoiceable',
            label: 'Fakturerbart',
            dataType: 'number'
          }
          */
        ]
      }
    }
  },
  watch: {
    'projects.filter': {
      handler () {
        this.getListData()
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      projects: state => state.projectsInvoice.all
    })
  },
  methods: {
    ...mapActions('projectsInvoice', ['initialize', 'getListData']),

    rowAction (action, project) {
      switch (action) {
        case 'reviewInvoice':
          this.openReviewModal(project.projectId)
          break
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    fieldAction (action, project) {
      switch (action) {
        case 'displayTags':
          this.$panel(ProjectModal, { id: project.projectId })
          break
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    tableAction (action) {
      this.$router.push({ name: 'Invoices_Archive' })
    },

    openReviewModal (id) {
      this.$panel(InvoicePreviewModal, { projectId: id }).then(() => {
        this.getListData()
      })
    }
  },

  mounted () {
    if (this.$route.params.projectCode) {
      this.defaultFilter.projectCode = this.$route.params.projectCode
    }
  },

  created () {
    this.initialize()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Invoices/InvoicesPage.vue